export default __webpack_public_path__ + "static/media/icon-defects.afdf0e39.svg";